import React, { Component, Fragment } from "react";
import Select from "react-select";
import { CSVLink } from "react-csv";
import Breadcrumb from "../common/breadcrumb";
import AuthService from "../services/auth.service";
import ApiService from "../services/api.service";
import { SortableTh, sortRows, nextSort } from "../common/sortable-th";
import { DateRangeInput } from "../common/date-range-input";
import "react-toastify/dist/ReactToastify.css";

function fmtMoney(val) {
    if (val === null || val === undefined || val === "") return "—";
    const num = parseFloat(val);
    if (isNaN(num)) return "—";
    return "S/ " + num.toLocaleString("es-PE", { minimumFractionDigits: 2, maximumFractionDigits: 2 });
}

const PRODUCT_HEADERS = [
    { label: "Producto", key: "name" },
    { label: "Categoría", key: "category" },
    { label: "Subcategoría", key: "subcategory" },
    { label: "Precio", key: "price" },
    { label: "Unidades", key: "quantity" },
    { label: "Total", key: "total" },
];

function csvFilename(customerLabel, from, to) {
    const safeCustomer = customerLabel ? customerLabel.replace(/\s+/g, "") : "cliente";
    const period = from ? `${from}_a_${to}` : "historial-completo";
    return `sku-por-cliente_${safeCustomer}_${period}.csv`;
}

export class VerReportSkuForMonthAndCustomer extends Component {
    constructor(props) {
        super(props);
        this.onChangeFilter = this.onChangeFilter.bind(this);
        this.handleSort = this.handleSort.bind(this);
        this.applyDateRange = this.applyDateRange.bind(this);
        this.clearDateRange = this.clearDateRange.bind(this);
        this.handleChangeCustomer = this.handleChangeCustomer.bind(this);

        this.state = {
            results: [],
            temp: [],
            filter: "",
            loading: false,
            hasSearched: false,
            dataCustomers: [],
            selectedCustomer: null,
            // sin fecha por defecto: elegir el cliente ya trae todo su
            // historial, la fecha es para acotar después (no un requisito)
            dateFrom: "",
            dateTo: "",
            page: 1,
            sort: { key: "total", dir: "desc" },
        };
    }

    componentWillMount() {
        this.getCustomers();
    }

    getCustomers() {
        const user = AuthService.getCurrentUser();
        // solo clientes que ya compraron alguna vez -- de lo contrario el
        // selector trae a todos los usuarios registrados, la mayoría sin
        // ninguna compra, y hace ruido al buscar
        ApiService.getCustomersWithPurchases(user.token).then((res) => {
            if (res && res.status === "success") {
                const items = res.data.map((row) => ({
                    value: row.id,
                    label: `${row.name} ${row.last_name}`,
                }));
                this.setState({ dataCustomers: items });
            }
        });
    }

    onChangeFilter(e) {
        const val = e.target.value.toLowerCase();
        this.setState({ filter: e.target.value });

        if (this.state.temp.length !== 0) {
            const columns = Object.keys(this.state.temp[0]);
            const rows = this.state.temp.filter((d) => {
                for (let i = 0; i < columns.length; i++) {
                    const col = columns[i];
                    if (d[col] && d[col].toString().toLowerCase().indexOf(val) > -1) return true;
                }
                return false;
            });
            this.setState({ results: rows, page: 1 });
        }

        e.preventDefault();
    }

    handleSort(key) {
        this.setState((prev) => ({
            sort: nextSort(prev.sort, key),
            page: 1,
        }));
    }

    handleChangeCustomer(selectedCustomer) {
        // al cambiar de cliente se resetea la fecha -- si quedara el rango
        // del cliente anterior, parecería que este no tiene compras cuando
        // en realidad seguís filtrado por un periodo que ya no aplica
        this.setState({ selectedCustomer, dateFrom: "", dateTo: "" }, () => {
            if (selectedCustomer) {
                this.fetchData();
            } else {
                this.setState({ results: [], temp: [], hasSearched: false });
            }
        });
    }

    applyDateRange(from, to) {
        this.setState({ dateFrom: from, dateTo: to }, () => {
            if (this.state.selectedCustomer) this.fetchData();
        });
    }

    clearDateRange() {
        this.setState({ dateFrom: "", dateTo: "" }, () => {
            if (this.state.selectedCustomer) this.fetchData();
        });
    }

    fetchData() {
        const user = AuthService.getCurrentUser();
        const { selectedCustomer, dateFrom, dateTo } = this.state;
        this.setState({ loading: true, hasSearched: true });

        ApiService.getProductsForCustomer(user.token, selectedCustomer.value, dateFrom, dateTo)
            .then((res) => {
                if (res && res.status === "success") {
                    const items = res.data.products || [];
                    this.setState({ results: items, temp: items, loading: false, page: 1 });
                } else {
                    this.setState({ results: [], temp: [], loading: false });
                }
            })
            .catch(() => {
                this.setState({ loading: false });
            });
    }

    renderPagination(total, page, pageSize, onPageChange) {
        const totalPages = Math.ceil(total / pageSize);
        if (totalPages <= 1) return null;
        const from = (page - 1) * pageSize + 1;
        const to = Math.min(page * pageSize, total);
        return (
            <div style={{
                display: "flex", flexWrap: "wrap", alignItems: "center", justifyContent: "space-between",
                padding: "10px 16px", borderTop: "1px solid #f0f0f0", gap: 8,
                background: "#fafafa", fontSize: 13, color: "#666",
            }}>
                <span style={{ fontSize: 12, color: "#aaa" }}>{from}–{to} de {total}</span>
                <div style={{ display: "flex", gap: 6 }}>
                    <button
                        disabled={page === 1}
                        onClick={() => onPageChange(page - 1)}
                        style={{
                            border: "1px solid #ddd", borderRadius: 6, padding: "4px 12px",
                            background: page === 1 ? "#f4f4f4" : "#fff",
                            color: page === 1 ? "#ccc" : "#333",
                            cursor: page === 1 ? "default" : "pointer", fontSize: 13,
                        }}
                    >
                        <i className="fa fa-chevron-left" />
                    </button>
                    <span style={{ padding: "4px 10px", fontSize: 13, color: "#555" }}>{page} / {totalPages}</span>
                    <button
                        disabled={page === totalPages}
                        onClick={() => onPageChange(page + 1)}
                        style={{
                            border: "1px solid #ddd", borderRadius: 6, padding: "4px 12px",
                            background: page === totalPages ? "#f4f4f4" : "#fff",
                            color: page === totalPages ? "#ccc" : "#333",
                            cursor: page === totalPages ? "default" : "pointer", fontSize: 13,
                        }}
                    >
                        <i className="fa fa-chevron-right" />
                    </button>
                </div>
            </div>
        );
    }

    renderResults() {
        const { results, page, sort, loading, hasSearched } = this.state;
        if (loading) return <div style={{ padding: 16, color: "#888" }}>Cargando...</div>;
        if (!hasSearched) {
            return <div style={{ padding: 16, color: "#888" }}>Elegí un cliente para ver su historial de compras.</div>;
        }
        if (results.length === 0) {
            return <div style={{ padding: 16, color: "#888" }}>Ese cliente no tiene compras en el periodo seleccionado.</div>;
        }

        const PAGE_SIZE = 50;
        const sorted = sortRows(results, sort);
        const totalPages = Math.max(1, Math.ceil(sorted.length / PAGE_SIZE));
        const currentPage = Math.min(page, totalPages);
        const paginated = sorted.slice((currentPage - 1) * PAGE_SIZE, currentPage * PAGE_SIZE);

        const headers = [
            { label: "Producto", key: "name", align: "left" },
            { label: "Categoría", key: "category", align: "left" },
            { label: "Subcategoría", key: "subcategory", align: "left" },
            { label: "Precio", key: "price", align: "right" },
            { label: "Unidades", key: "quantity", align: "right" },
            { label: "Total", key: "total", align: "right" },
        ];

        return (
            <div style={{ border: "1px solid #ebebeb", borderRadius: 10, overflow: "hidden" }}>
                <div style={{ overflowX: "auto" }}>
                    <table style={{ width: "100%", borderCollapse: "collapse", fontSize: 13 }}>
                        <thead>
                            <tr style={{ background: "#f8f9fa", borderBottom: "2px solid #ebebeb" }}>
                                {headers.map((h) => (
                                    <SortableTh key={h.key} header={h} sort={sort} onSort={this.handleSort} style={{ textAlign: h.align }} />
                                ))}
                            </tr>
                        </thead>
                        <tbody>
                            {paginated.map((item) => (
                                <tr
                                    key={item.id_product}
                                    style={{ borderBottom: "1px solid #f4f4f4" }}
                                    onMouseEnter={(e) => (e.currentTarget.style.background = "#f8fbff")}
                                    onMouseLeave={(e) => (e.currentTarget.style.background = "")}
                                >
                                    <td style={{ padding: "9px 12px", whiteSpace: "nowrap", fontWeight: 500, textAlign: "left" }}>{item.name}</td>
                                    <td style={{ padding: "9px 12px", whiteSpace: "nowrap", color: "#666", textAlign: "left" }}>{item.category}</td>
                                    <td style={{ padding: "9px 12px", whiteSpace: "nowrap", color: "#666", textAlign: "left" }}>{item.subcategory}</td>
                                    <td style={{ padding: "9px 12px", whiteSpace: "nowrap", color: "#666", textAlign: "right" }}>{fmtMoney(item.price)}</td>
                                    <td style={{ padding: "9px 12px", whiteSpace: "nowrap", textAlign: "right" }}>
                                        <span style={{ background: "#d4edda", color: "#155724", borderRadius: 10, padding: "2px 9px", fontSize: 12, fontWeight: 600 }}>
                                            {item.quantity}
                                        </span>
                                    </td>
                                    <td style={{ padding: "9px 12px", whiteSpace: "nowrap", fontWeight: 700, textAlign: "right" }}>{fmtMoney(item.total)}</td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                </div>
                {this.renderPagination(sorted.length, currentPage, PAGE_SIZE, (p) => this.setState({ page: p }))}
            </div>
        );
    }

    render() {
        const { selectedCustomer, results, sort, dateFrom, dateTo } = this.state;
        const sortedResults = sortRows(results, sort);

        return (
            <Fragment>
                <Breadcrumb title="Sku por Clientes" parent="Analítica" />

                <div className="container-fluid">
                    <div className="row">
                        <div className="col-sm-12">
                            <div className="card" style={{ marginBottom: 16 }}>
                                <div className="card-body" style={{ padding: "12px 16px" }}>
                                    <div style={{ display: "flex", flexWrap: "wrap", alignItems: "center", gap: 10 }}>
                                        <span style={{ fontSize: 13, fontWeight: 600, color: "#555", whiteSpace: "nowrap" }}>
                                            Cliente
                                        </span>
                                        <div style={{ minWidth: 240, flex: "1 1 240px", maxWidth: 360 }}>
                                            <Select
                                                placeholder="Buscar cliente..."
                                                value={selectedCustomer}
                                                onChange={this.handleChangeCustomer}
                                                options={this.state.dataCustomers}
                                                isClearable
                                            />
                                        </div>
                                        <span style={{ fontSize: 13, fontWeight: 600, color: "#555", whiteSpace: "nowrap" }}>
                                            Filtrar por fecha
                                        </span>
                                        <DateRangeInput
                                            from={dateFrom}
                                            to={dateTo}
                                            onApply={this.applyDateRange}
                                            disabled={!selectedCustomer}
                                            disabledHint="Elegí un cliente primero"
                                        />
                                        {dateFrom ? (
                                            <button
                                                type="button"
                                                onClick={this.clearDateRange}
                                                style={{ border: "none", background: "transparent", color: "#0d6efd", cursor: "pointer", fontSize: 12, padding: 0 }}
                                            >
                                                Ver todo el historial
                                            </button>
                                        ) : (
                                            <span style={{ fontSize: 12, color: "#999" }}>Mostrando todo el historial</span>
                                        )}
                                    </div>
                                </div>
                            </div>

                            <div className="card" style={{ boxShadow: "none", border: "1px solid #ebebeb" }}>
                                <div
                                    className="card-header"
                                    style={{
                                        display: "flex", flexWrap: "wrap", alignItems: "center",
                                        justifyContent: "space-between", gap: 10,
                                    }}
                                >
                                    <h5 style={{ margin: 0 }}>Productos comprados por el cliente</h5>
                                    <div style={{ display: "flex", flexWrap: "wrap", alignItems: "center", gap: 10 }}>
                                        <input
                                            placeholder="Buscar..."
                                            name="filter"
                                            type="text"
                                            className="form-control"
                                            autoComplete="off"
                                            onInput={this.onChangeFilter}
                                            style={{
                                                flex: "1 1 180px", minWidth: 140, maxWidth: 260,
                                                height: 32, boxSizing: "border-box", padding: "4px 10px",
                                            }}
                                        />
                                        {results.length > 0 && (
                                            <CSVLink
                                                className="btn btn-outline-primary btn-sm"
                                                data={sortedResults}
                                                headers={PRODUCT_HEADERS}
                                                filename={csvFilename(selectedCustomer && selectedCustomer.label, dateFrom, dateTo)}
                                                style={{
                                                    display: "inline-flex", alignItems: "center", height: 32,
                                                    flexShrink: 0, whiteSpace: "nowrap", boxSizing: "border-box",
                                                }}
                                            >
                                                <i className="fa fa-file-excel-o" style={{ marginRight: 6 }} />
                                                Exportar
                                            </CSVLink>
                                        )}
                                    </div>
                                </div>
                                <div className="card-body" style={{ padding: 0 }}>
                                    {this.renderResults()}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </Fragment>
        );
    }
}

export default VerReportSkuForMonthAndCustomer;
